<script>
  export let config = {};
  export let data = {};

  // let styles = {
  //   src: 'url(' + data.bacimg + ')',

  // };
  console.log('data', data);
</script>

<style>
  .feature {
    height: 600px;
    position: relative;
    background-position: 45% 50%;
    background-color: #111;
    background-position-y: var(--bac-img-posY, '');
  }
  @media (max-width: 599px) {
    .feature {
      background-image: var(--bac-img-src-sm, --bac-img-src);
    }
  }
  @media (max-width: 959px) and (min-width: 600px) {
    .feature {
      background-position: center;
      background-image: var(--bac-img-src-md, --bac-img-src);
    }
  }
  @media screen and (min-width: 960px) {
    .feature {
      height: 700px;
      background-position: center;
      background-size: cover;
      background-image: var(--bac-img-src);
    }
  }
  .gradient {
    position: absolute;
    z-index: 1;
    bottom: 0;
    left: 0;
    height: 200px;
    width: 100%;
    background: url("../io/grad-to-black-200.png") repeat-x;
  }
  .grid {
    grid-template-columns: 1fr;
    justify-items: center;
    align-items: center;
    height: 100%;
  }
  .grid.main {
    justify-items: center;
    align-items: end;
  }
  .title {
    z-index: 2;
    text-align: left;
  }
  .title.center {
    text-align: center;
  }
  @media screen and (min-width: 600px) {
    .grid.main {
      justify-items: end;
      align-items: center;
    }
  }
</style>

<section
  class="feature {config.class}"
  style="--bac-img-src: url({data.bacimg.src}); --bac-img-src-sm: url({data.bacimg.srcsm}); --bac-img-src-md: url({data.bacimg.srcmd}); --bac-img-posY: {data.bacimg.posY};"
  data-section="feature">
  {#if config.gradient}
    <div class="gradient" />
  {/if}
  {#if data.html}
    <div class="layout grid {config.gridClass}">
      <div class="title {config.titleClass}">
        {@html data.html}
      </div>
    </div>
  {/if}
</section>
